import { Link } from "react-router-dom";
import { FileText, Calendar } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/Card";
import { policies } from "../policies/policies-config";
import { format } from "date-fns";

export function Policies() {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-4">
          <FileText className="w-8 h-8 text-primary-600" />
          <h1 className="text-3xl font-bold text-gray-900">Policies</h1>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {policies.map((policy) => (
          <Link
            key={policy.slug}
            to={`/policies/${policy.slug}`}
            className="block"
          >
            <Card className="h-full hover:shadow-lg transition-shadow cursor-pointer">
              <CardHeader>
                <div className="flex items-start justify-between">
                  <CardTitle className="text-xl">{policy.title}</CardTitle>
                  <FileText className="w-5 h-5 text-primary-600 flex-shrink-0 ml-2" />
                </div>
              </CardHeader>
              <CardContent>
                {policy.description && (
                  <p className="text-gray-600 mb-4">{policy.description}</p>
                )}
                <div className="flex items-center text-sm text-gray-500">
                  <Calendar className="w-4 h-4 mr-2" />
                  <span>Last updated: {format(policy.lastUpdated, "MMMM d, yyyy")}</span>
                </div>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}





